import { useAxiosMutation } from "hooks";
import { axiosChartInstance } from "config";
import { useQueryClient } from "react-query";

type SignedSection =
  | "Discharge"
  | "Observation"
  | "Ama"
  | "Transfer"
  | "Allergies&Meds";

type CreateSignedSectionPayload = {
  type: SignedSection;
  input: FormData;
  override?: boolean;
};

function useCreateSignedSection(encounterId: string) {
  const queryClient = useQueryClient();
  return useAxiosMutation(
    ["createSignedSection", { encounterId }],
    ({ type, input, override }: CreateSignedSectionPayload) =>
      axiosChartInstance.post(
        `v1/sectionSummary/${encounterId}/signed-section/${type}`,
        input,
        {
          params: { isOverride: override ?? false },
        }
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["signedSectionsFiles", { encounterId }]);
        queryClient.invalidateQueries(["getSignedSection", { encounterId }]);
      },
    }
  );
}

export type { SignedSection };
export { useCreateSignedSection };
